module.exports = __webpack_public_path__ + "media/localization/russian-fd0e7461.png";